<template>
  <v-snackbar v-model="notify.show" :color="notify.type || 'error'">
    {{ notify.message }}
    <template v-slot:action="{ attrs }">
      <v-btn dark text v-bind="attrs" @click="hide"> إغلاق </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    notify: {
      type: Object,
      required: true,
    },
  },
  computed: {
    notifyTypeColor() {
      return this.notify.type;
    },
  },
  methods: mapActions("notify", ["hide"]),
};
</script>